import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made with ❤️ by Pranav Tiwari")}
        </p>
        {/* <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          Check out my terminal portfolio {" "}
          <a href="https://6440442ae94cf519940b0ad2--pshell.netlify.app/">
            PShell
          </a>
        </p> */}
      </div>
    </Fade>
  );
}
